import React, { useState } from 'react'
import { useSelector } from 'react-redux'

import JobsFilters from './JobsFilters'
import JobsList from './JobsList'
import FAQ from '../../components/Shared/FAQ'

import { selectSearchJobsPagination } from '../../routing/fetchingfunction/jobSearch/jobSearch.reducer'
import useDebounce from '../../hooks/useDebounce'

import searchIcon from '../../assets/icon/search.png'

const Jobs = () => {
  const { jobsTotal } = useSelector(selectSearchJobsPagination)

  const [search, setSearch] = useState('')
  const [filters, setFilters] = useState({
    job_category: '_',
    price: '_',
    posted: '_',
    price_type: '_',
    languages: '_',
    ordering: 'name_a_z',
  })

  const debouncedSearch = useDebounce(search)

  const handleChangeSearch = (e) => {
    setSearch(e.target.value)
  }

  return (
    <>
      <div className="max-w-[1280px] w-full mx-auto pt-[32px] pb-[60px] flex flex-col items-start">
        <div className="w-full flex items-center justify-center flex-col">
          <h1 className="text-4xl text-white font-bold leading-[52px] text-center">
            Need Someone To Work On A Job For You?
            <br />
            Find Real Professionals through Our Tutors!
          </h1>

          <div className="mt-[32px] w-full flex flex-col items-start">
            <label className="w-[480px] relative flex items-center">
              <input
                placeholder="Search with keywords"
                value={filters.search}
                onChange={handleChangeSearch}
                className="h-[56px] pl-[24px] pr-[48px] w-full bg-transparent rounded-[10px] text-base border-[#FDFDFD] border-[1px] text-[#FDFDFD] placeholder:text-[#FDFDFD] outline-none"
              />

              <img
                src={searchIcon}
                alt="Search"
                draggable={false}
                className="absolute right-[24px]"
              />
            </label>

            <h2 className="text-[18px] mt-[16px] leading-[30px] text-[#FDFDFD] font-bold">
              {jobsTotal} job post{jobsTotal > 1 ? 's' : ''} found
            </h2>

            <div className="mt-[24px] w-full flex items-start gap-[24px]">
              <div className="w-[300px] flex flex-col items-start">
                <JobsFilters filters={filters} onChange={setFilters} />
              </div>

              <div className="flex-1 flex flex-col items-start">
                <JobsList filters={filters} search={debouncedSearch} />
              </div>
            </div>
          </div>
        </div>
      </div>

      <FAQ />
    </>
  )
}

export default Jobs
